import React from "react";
import { SwiggySixesCommState, SwiggySixesTickerTimer, TimerUpdateSource } from "@swiggy-private/core-types";

export interface CartIPLSwiggySixesContextValue {
    timestampInMs?: number;
    tickerTimerInMinSec: SwiggySixesTickerTimer;
    croutonCommsState: SwiggySixesCommState;
    validateAndSetTimestamp?: (timerInSec?: number, source?: TimerUpdateSource) => void;
    cleanupTickerTimer?: VoidFunction;
    disableTickerTimerAndComms?: VoidFunction;
    cleanupAppJSBridgeHandler?: VoidFunction;
    setCroutonTrackingInSession?: (value: boolean) => void;
    isCroutonEnabledInSession?: () => boolean;
}

const DEFAULT_VALUE = {
    tickerTimerInMinSec: {
        enabled: false,
    },
    croutonCommsState: SwiggySixesCommState.DISABLED,
};

export const CartIPLSwiggySixesContext = React.createContext<CartIPLSwiggySixesContextValue>(DEFAULT_VALUE);

if (__DEV__) {
    CartIPLSwiggySixesContext.displayName = "CartIPLSwiggySixesContext";
}
